// Contexto de trade pack (spec 2026-07-27 §5.3). Funções puras: o field app
// resolve "qual trade estou olhando" a partir do projeto selecionado e das
// flags da org — nada de estado aplicado uma vez por sessão.
import { formKeyFor } from './schemas.js';

const PREFIX = 'trade_pack_';

export function activePacks(features) {
  const f = features || {};
  return Object.keys(f)
    .filter(k => k.indexOf(PREFIX) === 0 && f[k] === true)
    .map(k => k.slice(PREFIX.length));
}

// Trade "ativo" para um projeto: o trade do projeto — DESDE QUE o pack dele
// ainda esteja ligado; senão, o único pack da org (orgs de 1 pack não
// precisam etiquetar projetos); senão null (geral). A guarda existe porque
// remover um pack não apaga a etiqueta dos projetos, e uma etiqueta órfã
// ressuscitava o pack desligado (variantes de schema continuam no banco) —
// FLRA do trade antigo + catálogo vazio (2026-07-28).
export function tradeForProject(projectName, projectTrades, features) {
  const active = activePacks(features);
  const t = (projectTrades || {})[projectName];
  if (t && active.includes(t)) return t;
  return active.length === 1 ? active[0] : null;
}

// Neutros que este pack esconde — form_keys copiados de
// trade_packs.content.hidden_neutral_forms para features.pack_hidden[pack]
// na hora do import (Task 6). Dado inicial: vazio (tudo visível).
export function hiddenNeutralForms(features, trade) {
  const list = (features || {}).pack_hidden?.[trade];
  return new Set(Array.isArray(list) ? list : []);
}

// Forms crews don't see right now: the trade's pack defaults (only with a
// trade in context, as before), then the admin's own "Show to crews" choices
// (features.crew_forms: form_key -> true/false, Settings > Forms). The choices
// sit outside pack_hidden on purpose: the pack importer rewrites and removing a
// pack deletes that list, and a new pack must not undo what the admin hid.
export function hiddenForms(features, trade) {
  const active = activePacks(features);
  const hidden = trade && active.includes(trade) ? hiddenNeutralForms(features, trade) : new Set();
  for (const [k, show] of Object.entries((features || {}).crew_forms || {})) {
    if (show === true) hidden.delete(k);
    else if (show === false) hidden.add(k);
  }
  return hidden;
}

export function visibleTypes(allTypes, { features, trade }) {
  const active = activePacks(features);
  const hidden = hiddenForms(features, trade);
  const inTrade = trade && active.includes(trade);
  return allTypes.filter(t =>
    (inTrade ? (!t.pack || t.pack === trade) : (!t.pack || active.includes(t.pack))) &&
    !hidden.has(formKeyFor(t.id)));
}
